import { render } from "./LongListPage.vue?vue&type=template&id=4daae234&scoped=true"
import script from "./LongListPage.vue?vue&type=script&lang=js"
export * from "./LongListPage.vue?vue&type=script&lang=js"

import "./LongListPage.vue?vue&type=style&index=0&id=4daae234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4daae234"]])

export default __exports__